module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("crGNx"))).then(() => parcelRequire('hEqeo'));